import g from 'glamorous'

const HeaderContainer = g.div(({ theme }) => {
  return {
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'nowrap',
    paddingTop: '1em',
    paddingBottom: '1em'
  }
})

export default HeaderContainer



// WEBPACK FOOTER //
// ./src/components/HeaderContainer.tsx